<template>
  <div>
    <modal-confirmacion
      @error="toastError($event)"
      @saveSlots="saveSlots"
      @changeName="nombreSlots = $event"
      :showLoading="showloadingConfirmacionHorarios"
      :nombreSlots="nombreSlots"
    ></modal-confirmacion>

    <div
      v-if="categoriaActiva"
      class="assign-indicator"
      :style="{
        backgroundColor: categoriaActiva.color,
        transform: `translate(${mouse.x + 12}px, ${mouse.y + 12}px)`,
      }"
    >
      Asignando: {{ categoriaActiva.text }}
    </div>
    <modal-horarios
      :isCreando="isCreandoHorarios"
      :listCategorias="listCategorias"
      :listDias="listDias"
      :listConfiguraciones="listConfiguraciones.configs"
      :showLoading="showLoadingModal"
      :categoriasSeleccionadas="categoriasSeleccionadas"
      @vistaPrevia="dibujarVistaPrevia($event)"
      @cierraHorario="cerrarModalHorario"
      @getDataHorariosBlank="getDataHorariosBlank"
      @inicializaVariables="inicializaVariables"
      @updateCategoriasSeleccionadas="updateCategoriasSeleccionadas($event)"
      @changeConfig="changeConfig($event)"
      @cerrarModoCreacion="cerrarModoCreacion"
    ></modal-horarios>
    <b-tabs pills>
      <b-tab title="Slots" active @click="getSlotsconfig">
        <b-card no-body class="p-1">
          <b-overlay :show="showloadingContenidoSlots" rounded="sm">
            <b-row>
              <b-col md="5">
                <v-select
                  :options="listConfigSlots"
                  @input="getSlots"
                  placeholder="Sel. Config Slots"
                  :clearable="false"
                  v-model="slotSeleccionado"
                />
              </b-col>
              <b-col md="1">
                <b-button
                  v-if="
                    USER().rol === ROLES.SUPER ||
                      USER().rol === ROLES.ADMIN ||
                      USER().rol === ROLES.TECNICA
                  "
                  v-b-tooltip.hover.v-primary
                  title="Crear Slots"
                  variant="flat-primary"
                  class="btn-icon"
                  @click="openModalHorarios"
                >
                  <feather-icon size="22" icon="PlusIcon" />
                </b-button>
              </b-col>
            </b-row>
            <template v-if="dias.length != 0">
              <div style="margin-bottom:10px" class="toggle-group">
                <div
                  v-for="opt in optionsCheckbox"
                  :key="opt.value"
                  class="toggle-item"
                  :class="{ active: selectedCategoria === opt.value }"
                  :style="
                    selectedCategoria === opt.value
                      ? {
                          backgroundColor: opt.color,
                          color: '#fff',
                          fontSize: '13px',
                        }
                      : {}
                  "
                  @click="select(opt.value)"
                >
                  <div
                    style="width:10px; height:10px; display:inline-block"
                    :style="{ backgroundColor: opt.color }"
                  ></div>
                  {{ opt.text }}
                  <div
                    style="font-size:10px;font-weight: 400"
                    :style="
                      selectedCategoria === opt.value
                        ? { backgroundColor: opt.color, color: '#fff' }
                        : {}
                    "
                  >
                    # horarios prioridad: {{ opt.contador }} / # slots
                    disponibles:
                    {{ opt.slotsDisponibles }}
                  </div>
                </div>
              </div>
              <div
                style="display:flex; justify-content: space-between; align-items:center; width:100%;"
              >
                <!-- IZQUIERDA -->
                <div>
                  <span class="disponibles"
                    >Total Slots Disponibles: {{ totalSlotsDisponibles }}</span
                  >
                  <span class="bloqueados"
                    >Total Slots Bloqueados: {{ totalSlotsBloqueados }}</span
                  >
                </div>

                <!-- DERECHA -->
                <div>
                  <div class="prioridad" v-if="hayPrioridades">
                    Existen categorias con prioridad de horarios
                  </div>
                  <div class="no-prioridad" v-else>
                    Las categorias tratadas pueden ser asignadas a cualquier
                    horario
                  </div>
                </div>
              </div>
              <div
                class="grid-wrapper"
                :class="{ 'assign-mode': categoriaActiva }"
              >
                <!-- HEADER -->
                <div
                  class="grid header"
                  :style="{ gridTemplateColumns: gridColumns }"
                >
                  <!-- FILA 1 -->
                  <div class="cell-header">Franja</div>
                  <div v-for="dia in dias" :key="dia.dia" class="cell-header">
                    {{ dia.dia }}
                  </div>

                  <!-- FILA 2 -->
                  <div class="cell-header "></div>
                  <div
                    v-for="dia in dias"
                    :key="dia.dia + '-sub'"
                    class="cell-header"
                  >
                    <div class="canchas-grid">
                      <div
                        v-for="(n, index) in Number(dia.canchas)"
                        :key="index"
                        class="subcancha"
                      >
                        Cancha{{ n }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- BODY -->
                <div
                  class="grid body"
                  :style="{ gridTemplateColumns: gridColumns }"
                >
                  <div
                    v-for="franja in franjas"
                    :key="franja.hora"
                    class="franja-row"
                  >
                    <!-- FRANJA SIEMPRE EN COLUMNA 1 -->
                    <div class="cell franja-cell" style="grid-column: 1">
                      <div>{{ franja.hora }}</div>
                    </div>

                    <!-- CELDAS DE LOS DÍAS -->
                    <div
                      v-for="(dia, index) in dias"
                      :key="index + franja.hora"
                      class="cell"
                      :class="{
                        'modo-asignacion': modoAsignacion,
                      }"
                      :style="celdaStyle(dia, franja.hora)"
                      @click="
                        dia.slots.includes(franja.hora) &&
                          asignarCelda(dia, franja.hora)
                      "
                      @contextmenu.prevent="
                        dia.slots.includes(franja.hora) &&
                          desasignarCelda(dia, franja.hora)
                      "
                    >
                      <!-- SOLO si existe el slot -->
                      <div
                        v-if="dia.slots.includes(franja.hora)"
                        class="canchas-grid"
                        :style="{
                          gridTemplateColumns: `repeat(${dia.canchas}, 1fr)`,
                        }"
                      >
                        <div
                          v-for="(n, index) in Number(dia.canchas)"
                          :key="index"
                          class="cancha-activa"
                          :style="getCanchaStyle(dia, franja.hora, index)"
                          @dblclick.stop="
                            toggleBloqueoCancha(dia, franja.hora, index)
                          "
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <p style="color: darkred;font-size: 10px;font-weight: bolder;">
                  Si desea bloquear o desbloquear una cancha de doble click
                  sobre la misma(Se recomienda no estar en modo asignación)
                </p>
              </div>
              <div
                v-if="modoAsignacion"
                style="text-align:center;justify-content: center; display: flex;"
                @click="salirmodoAsignacion"
              >
                <p class="mensaje-salir-modo">
                  Usted esta en el modo asignación si desea salir de este modo
                  presione ESC o de click aqui
                </p>
              </div>
              <b-button
                v-if="
                  isDibujadoSlot &&
                    (USER().rol === ROLES.SUPER ||
                      USER().rol === ROLES.ADMIN ||
                      USER().rol === ROLES.TECNICA)
                "
                v-b-tooltip.hover.v-primary
                title="Generador horarios"
                variant="primary"
                class="btn-icon mt-2"
                @click="openModalConfirmacion"
              >
                Guardar
              </b-button>
            </template>
          </b-overlay>
        </b-card>
      </b-tab>
      <b-tab title="Asignacion" @click="getSlotsconfigAsignaciones">
        <asignacion
          :listConfigSlotsAsignaciones="listConfigSlotsAsignaciones"
        ></asignacion>
      </b-tab>
      <b-tab
        title="Resumen Programaciones"
        @click="cargarSelectsResumenProgramaciones"
      >
        <resumen-programaciones
          :listHistoriales="listHistoriales"
          :refresh="refreshA"
          @exitoCanchas="cargarSelectsResumenProgramaciones()"
        ></resumen-programaciones>
      </b-tab>

      <b-tab title="Historial">
        <resumen-equipo
          :listHistoriales="listHistoriales"
          :resumen="resumen"
        ></resumen-equipo>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import {
  BTabs,
  BTab,
  BCard,
  BRow,
  BCol,
  BButton,
  VBTooltip,
  BOverlay,
  //   xx,
  //   xx,
  //   xx,
  //   xx,
  //   xx,
} from 'bootstrap-vue'
import {
  ref,
  computed,
  watch,
  onMounted,
  reactive,
  // xx,
  //   xx,
  //   xx,
  //   xx,
  //   xx,
} from '@vue/composition-api'
import vSelect from 'vue-select'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  URL,
  USER,
  ROLES,
  //   DISCIPLINAS,
  // ACTION_INSERT
} from '../../utils/variables'
import apiCall from '../../utils/apiCall'
import ModalHorarios from './ModalHorarios.vue'
import Asignacion from './Asignacion.vue'
import ModalConfirmacion from './ModalConfirmacion.vue'
import ResumenEquipo from './ResumenEquipo.vue'
import ResumenProgramaciones from './ResumenProgramaciones.vue'

export default {
  components: {
    BTabs,
    BTab,
    BCard,
    BRow,
    BCol,
    vSelect,
    BButton,
    BOverlay,
    ModalHorarios,
    Asignacion,
    ModalConfirmacion,
    ResumenEquipo,
    ResumenProgramaciones,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  setup() {
    const { postApi, getApi } = apiCall()
    const listConfigSlots = ref([])
    const listConfigSlotsAsignaciones = ref([])
    const dias = ref([])
    const franjas = ref([])
    const franjasSend = ref([])

    const selectedCheckbox = ref([])
    const selectedCategoria = ref(null)
    const optionsCheckbox = ref([])
    const categoriaActiva = ref(null)
    const modoAsignacion = ref(false)
    const isCreandoHorarios = ref(false)
    const listCategorias = ref([])
    const listDias = ref([])
    const listConfiguraciones = ref([])
    const showLoadingModal = ref(false)
    const categoriasSeleccionadas = ref([])
    const isDibujadoSlot = ref(false)
    const showloadingContenidoSlots = ref(false)
    const showloadingConfirmacionHorarios = ref(false)
    const configSelected = ref(null)
    const nombreSlots = ref(null)
    const refreshA = ref(0)
    const slotSeleccionado = ref({
      label: 'Seleccione slots',
      value: null,
    })
    const mouse = reactive({ x: 0, y: 0 })
    const resumen = ref([])
    const resumenHoras = ref([])
    const horas = ref([])
    const listHistoriales = ref([])
    const resumenDiaHora = ref({})
    const refreshProgramaciones = () => {
      refreshA.value += 1
      // console.log(refreshA.value)
    }
    const cargarResumenEquipo = async () => {
      resumen.value = []
      const path = 'ApiFixture/resumenEquipos/1'
      const data = await getApi(URL, path)
      resumen.value = data
      // console.log(data)
    }
    const cargarResumenDiaHora = async () => {
      resumenDiaHora.value = {}
      const path = 'ApiFixture/resumenDiaHora/1'
      const data = await getApi(URL, path)
      resumenDiaHora.value = data
      // console.log(data)
    }

    const cargarSelectsResumenProgramaciones = async () => {
      listHistoriales.value = []
      const path = 'ApiConfiguration/getHistorialesYGeneraciones'
      const data = await getApi(URL, path)
      listHistoriales.value = data
      refreshProgramaciones()
      // console.log(data)
    }
    const cargarResumenHorarios = async () => {
      const path = 'ApiFixture/resumenHoras/1'
      const data = await getApi(URL, path)
      resumenHoras.value = data.equipos
      horas.value = data.horas
      // console.log(data)
    }
    window.addEventListener('mousemove', e => {
      mouse.x = e.clientX
      mouse.y = e.clientY
    })
    function handleKeydown(e) {
      if (e.key === 'Escape') {
        modoAsignacion.value = false
        categoriaActiva.value = null
        selectedCategoria.value = null
      }
    }
    function salirmodoAsignacion() {
      modoAsignacion.value = false
      categoriaActiva.value = null
      selectedCategoria.value = null
    }
    function toggleBloqueoCancha(dia, hora, index) {
      if (!dia.asignaciones) return

      const slot = dia.asignaciones[hora]
      if (!slot) return

      if (!slot.bloqueos) {
        slot.bloqueos = []
      }

      const canchaReal = index + 1

      const bloqueo = slot.bloqueos.find(b => Number(b.cancha) === canchaReal)

      // 🔁 SI EXISTE → toggle
      if (bloqueo) {
        bloqueo.estado = !bloqueo.estado
      } else {
        // ➕ SI NO EXISTE → crear bloqueado
        slot.bloqueos.push({
          cancha: canchaReal,
          estado: true,
        })
      }
    }
    function toastError(mensaje) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: mensaje,
            icon: 'AlertCircleIcon',
            variant: 'danger',
            solid: true,
          },
        },
        {
          position: 'top-center',
          // eslint-disable-next-line
        },
      )
    }
    function updateCategoriasSeleccionadas(items) {
      categoriasSeleccionadas.value = items
      // console.log(categoriasSeleccionadas.value)
    }
    function changeConfig(item) {
      // console.log(item)
      // categoriasSeleccionadas.value = item.categorias
      categoriasSeleccionadas.value = item?.categorias?.map(c => c.value) ?? []
      listDias.value = item.dias
      listCategorias.value = listConfiguraciones.value.utils.categorias
      // console.log(categoriasSeleccionadas.value)
    }
    async function getSlotsconfig() {
      listConfigSlots.value = []
      slotSeleccionado.value = null
      dias.value = []
      franjas.value = []
      franjasSend.value = []
      salirmodoAsignacion()
      // isCreando.value = true
      // showLoadingModal.value = true
      const path = `ApiConfiguration/getSlotsConfig/${store.getters['someVariables/getTorneoSeleccionado'].id_torneo}`
      const data = await getApi(URL, path)
      listConfigSlots.value = data
      // console.log(listConfigSlots)
      // showLoadingModal.value = false
    }
    async function getSlotsconfigAsignaciones() {
      listConfigSlotsAsignaciones.value = []
      // isCreando.value = true
      // showLoadingModal.value = true
      const path = `ApiConfiguration/getSlotsConfigsAsignacion/${store.getters['someVariables/getTorneoSeleccionado'].id_torneo}`
      const data = await getApi(URL, path)
      listConfigSlotsAsignaciones.value = data
      // showLoadingModal.value = false
    }
    function dibujarVistaGuardad(item) {
      // console.log(item)
      //  dias: listPreviaDias.value,
      //   franjas: listPreviaFranjas.value,
      //   categorias: categoriasSeleccionadasObjetos.value,
      //   franjasSend: response.franjas,
      //   id_fixture_configuracion: configuracionSelected.value,
      dias.value = item.dias
      franjas.value = item.franjas_aux
      franjasSend.value = item.franjas
      // const categorias = item.categorias
      // configSelected.value = item.id_fixture_configuracion
      // optionsCheckbox.value = item.categorias
      optionsCheckbox.value = item.categorias.map(c => ({
        ...c,
        contador: c.contador ?? 0,
      }))
      isDibujadoSlot.value = true
    }
    function recalcularContadores() {
      // 🔄 resetear todos
      optionsCheckbox.value.forEach(c => {
        c.contador = 0
        c.slotsDisponibles = 0
      })

      // 🔍 recorrer dias
      dias.value.forEach(dia => {
        if (!dia.asignaciones) return

        Object.values(dia.asignaciones).forEach(cat => {
          if (!cat || cat.value === 0) return

          const encontrada = optionsCheckbox.value.find(
            c => c.value === cat.value,
          )

          if (encontrada) {
            // console.log(encontrada)
            // console.log(dia)

            encontrada.contador += 1
            encontrada.slotsDisponibles += Number(dia.canchas)
          }
        })
      })
    }

    async function getSlots() {
      // console.log(slotSeleccionado.value)
      showloadingContenidoSlots.value = true
      salirmodoAsignacion()
      // isCreando.value = true
      // showLoadingModal.value = true
      const path = `ApiFixture/getSlots/${slotSeleccionado.value.value}`
      const data = await getApi(URL, path)
      dibujarVistaGuardad(data)
      recalcularContadores()
      showloadingContenidoSlots.value = false
      // showLoadingModal.value = false
    }
    async function getDataConfigHorarios() {
      // console.log(grupoClick)
      listCategorias.value = []
      listDias.value = []
      listConfiguraciones.value = []
      // isCreando.value = true
      showLoadingModal.value = true
      const path = `ApiConfiguration/getConfiguracionesHorarios/${store.getters['someVariables/getTorneoSeleccionado'].id_torneo}`
      const data = await getApi(URL, path)
      listConfiguraciones.value = data
      // listCategorias.value = data.utils.categorias
      // listDias.value = data.utils.dias
      showLoadingModal.value = false
    }
    async function getDataHorariosBlank() {
      // console.log(grupoClick)
      listCategorias.value = []
      listDias.value = []
      categoriasSeleccionadas.value = []
      isCreandoHorarios.value = true
      // isCreando.value = true
      showLoadingModal.value = true
      const path = `ApiConfiguration/getUtilsHorarios/${store.getters['someVariables/getTorneoSeleccionado'].id_torneo}`
      const data = await getApi(URL, path)
      listCategorias.value = data.categorias
      listDias.value = data.dias
      showLoadingModal.value = false
    }
    function select(value) {
      selectedCategoria.value = value
      categoriaActiva.value = optionsCheckbox.value.find(o => o.value === value)
      modoAsignacion.value = true
    }

    function getCanchaStyle(dia, hora, index) {
      const slot = dia.asignaciones?.[hora]

      if (!slot) return {}

      // 🔒 buscar bloqueo por cancha real
      const bloqueo = slot.bloqueos?.find(b => Number(b.cancha) === index + 1)
      // console.log(bloqueo)

      if (bloqueo?.estado) {
        return {
          backgroundColor: '#9e9e9e',
          border: '1px solid #616161',
          cursor: 'not-allowed',
        }
      }

      if (slot.value && slot.value !== 0) {
        return {
          backgroundColor: slot.color,
          color: '#fff',
        }
      }

      if (modoAsignacion.value && categoriaActiva.value) {
        return {
          //          border: 1px solid #ccc;
          // border-radius: 6px;
          background: '#f9f9f9',
          backgroundColor: '#f9f9f9',
          border: '1px solid #ccc',
        }
      }

      return {}
    }

    // function asignarCelda(dia, hora) {
    //   if (!modoAsignacion.value || !categoriaActiva.value) return

    //   if (!dia.asignaciones) dia.asignaciones = {}

    //   dia.asignaciones[hora] = { ...categoriaActiva.value }

    //   recalcularContadores()
    // }
    function asignarCelda(dia, hora) {
      if (!modoAsignacion.value || !categoriaActiva.value) return

      const slot = dia.asignaciones?.[hora]

      // 🔒 validar si TODAS las canchas están bloqueadas
      const todasBloqueadas = slot?.bloqueos?.every(b => b.estado)

      if (todasBloqueadas) return

      if (!dia.asignaciones) dia.asignaciones = {}

      dia.asignaciones[hora] = {
        ...categoriaActiva.value,
        bloqueos: slot?.bloqueos ?? [],
      }

      recalcularContadores()
    }
    function desasignarCelda(dia, hora) {
      if (!dia.asignaciones || !dia.asignaciones[hora]) return
      const slot = dia.asignaciones[hora]
      dia.asignaciones[hora] = {
        value: 0,
        text: null,
        color: null,
        bloqueos: slot?.bloqueos ?? [], // 🔥 NO perder bloqueos
      }

      recalcularContadores()
    }

    function celdaStyle() {
      // const cat = dia.asignaciones?.[hora]
      // if (!cat) return {}

      // return {
      //   backgroundColor: cat.color,
      //   borderColor: cat.color,
      //   border: '1px solid #e0e0e0',
      // }
      return {}
    }
    // const CANCHA_WIDTH = 34
    // const CANCHA_GAP = 4
    // const MIN_DIA_WIDTH = 120
    // const CELL_PADDING_X = 28
    const ANCHO_CANCHA = 50
    const GAP = 4
    const PADDING_X = 16
    const gridColumns = computed(() => {
      const franjaCol = '80px'

      // if (!dias.value || !dias.value.length) {
      //   return `150px repeat(5, ${MIN_DIA_WIDTH}px)`
      // }

      const diasCols = dias.value.map(dia => {
        // console.log(dia)
        const canchas = Number(dia.canchas) || 1

        // const canchasWidth = canchas * CANCHA_WIDTH + (canchas - 1) * CANCHA_GAP

        // const totalWidth = canchasWidth + CELL_PADDING_X * 2

        // return `${Math.max(totalWidth, MIN_DIA_WIDTH)}px`

        const width = canchas * ANCHO_CANCHA + (canchas - 1) * GAP + PADDING_X

        return `${width}px`
      })

      return [franjaCol, ...diasCols].join(' ')
    })
    const totalSlotsDisponibles = computed(() => {
      let total = 0

      dias.value.forEach(dia => {
        if (!dia.activo) return

        const canchas = Number(dia.canchas) || 0

        dia.slots.forEach(hora => {
          const slot = dia.asignaciones?.[hora]

          // 🔥 contar bloqueos en esa hora
          let bloqueadas = 0

          if (slot?.bloqueos) {
            bloqueadas = slot.bloqueos.filter(b => b.estado).length
          }

          // total de ese slot - bloqueadas
          total += canchas - bloqueadas
        })
      })

      return total
    })
    const totalSlotsBloqueados = computed(() => {
      let total = 0

      dias.value.forEach(dia => {
        if (!dia.activo) return

        dia.slots.forEach(hora => {
          const slot = dia.asignaciones?.[hora]

          if (slot?.bloqueos) {
            total += slot.bloqueos.filter(b => b.estado).length
          }
        })
      })

      return total
    })
    const hayPrioridades = computed(
      () => optionsCheckbox.value.some(c => c.contador > 0),
      // eslint-disable-next-line
    )
    const cambioTorneo = computed(
      // eslint-disable-next-line
      () => store.getters['someVariables/getTorneoSeleccionado'],
    )
    const prioridadCategoria = computed(
      () =>
        // eslint-disable-next-line
        optionsCheckbox.value.some(c => c.contador !== 0),
      // eslint-disable-next-line
    )
    function openModalConfirmacion() {
      salirmodoAsignacion()
      store.commit('someVariables/UPDATE_SHOW_SLOTS', true)
    }
    async function saveSlots(item) {
      showloadingConfirmacionHorarios.value = true
      const data = {
        dias: dias.value,
        franjas: franjasSend.value,
        categorias: optionsCheckbox.value,
        prioridadCategoria: prioridadCategoria.value,
        id_fixture_configuracion:
          configSelected.value?.id_fixture_configuracion ?? null,
        nombre: item.name,
        idTorneo:
          store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
      }
      const path = 'ApiFixture/reciveDataSlots'
      const response = await postApi(URL, path, data)
      if (response.flag === 'si') {
        store.commit('someVariables/UPDATE_SHOW_SLOTS', false)
        getSlotsconfig()
        getSlotsconfigAsignaciones()
        nombreSlots.value = null
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'Slots creados exitosamente',
              icon: 'AlertCircleIcon',
              variant: 'success',
              solid: true,
            },
          },
          {
            position: 'bottom-center',
            // eslint-disable-next-line
          },
        )
      } else {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: response.mensaje,
              icon: 'AlertCircleIcon',
              variant: 'danger',
              solid: true,
            },
          },
          {
            position: 'bottom-center',
            // eslint-disable-next-line
          },
        )
      }
      showloadingConfirmacionHorarios.value = false
      // console.log(response)
    }
    // function transformCampeonatos(array, salida) {
    //   array.forEach(element => {
    //     const obj = {
    //       label: `${element.anio_inic} - ${element.anio_fin}`,
    //       value: element.id_campeonato,
    //       id_torneo: element.id_torneo,
    //       activo: element.activo,
    //     }
    //     salida.value.push(obj)
    //   })
    // }
    watch(cambioTorneo, () => {
      //   selectEtapas.value = null
      //   listEtapas.value = []
      getSlotsconfig()
      getSlotsconfigAsignaciones()

      // transformCampeonatos(
      //   store.getters['someVariables/getTorneoSeleccionado'].campeonatos,
      //   // eslint-disable-next-line
      //   listCampeonatos,
      // )
      // getListCategorias(data.id_torneo)
    })
    onMounted(() => {
      getSlotsconfig()
      getSlotsconfigAsignaciones()
      // transformCampeonatos(
      //   store.getters['someVariables/getTorneoSeleccionado'].campeonatos,
      //   // eslint-disable-next-line
      //   listCampeonatos,
      // )
      // const campActivo = listCampeonatos.value.find(
      //   // eslint-disable-next-line
      //   element => element.activo === 's',
      // )
      // campeonatoSeleccionado.value = campActivo
      window.addEventListener('keydown', handleKeydown)
    })
    function openModalHorarios() {
      salirmodoAsignacion()
      if (!isCreandoHorarios.value) {
        getDataConfigHorarios()
      }
      store.commit('someVariables/UPDATE_SHOW_MODAL_HORARIOS', true)
    }

    function dibujarVistaPrevia(item) {
      // console.log(item)
      dias.value = item.dias
      franjas.value = item.franjas
      franjasSend.value = item.franjasSend
      configSelected.value = item.id_fixture_configuracion
      // optionsCheckbox.value = item.categorias
      optionsCheckbox.value = item.categorias.map(c => ({
        ...c,
        contador: c.contador ?? 0,
      }))
      isDibujadoSlot.value = true
    }

    function cerrarModalHorario() {
      // listCategorias.value = []
      // listDias.value = []
      categoriasSeleccionadas.value = []
    }
    function inicializaVariables() {
      listCategorias.value = []
      listDias.value = []
      categoriasSeleccionadas.value = []
      isCreandoHorarios.value = false
    }
    function cerrarModoCreacion() {
      listCategorias.value = []
      listDias.value = []
      categoriasSeleccionadas.value = []
      isCreandoHorarios.value = false
      store.commit('someVariables/UPDATE_SHOW_MODAL_HORARIOS', false)
    }
    return {
      slotSeleccionado,
      USER,
      ROLES,
      openModalHorarios,
      dibujarVistaPrevia,
      dias,
      franjas,
      gridColumns,
      // CANCHA_WIDTH,
      selectedCheckbox,
      optionsCheckbox,
      select,
      selectedCategoria,
      categoriaActiva,
      mouse,
      asignarCelda,
      celdaStyle,
      modoAsignacion,
      desasignarCelda,
      saveSlots,
      isCreandoHorarios,
      cerrarModalHorario,
      getDataHorariosBlank,
      listCategorias,
      listDias,
      showLoadingModal,
      inicializaVariables,
      categoriasSeleccionadas,
      updateCategoriasSeleccionadas,
      listConfiguraciones,
      changeConfig,
      openModalConfirmacion,
      toastError,
      isDibujadoSlot,
      listConfigSlots,
      listConfigSlotsAsignaciones,
      getSlots,
      resumen,
      cargarResumenEquipo,
      cargarResumenHorarios,
      horas,
      resumenHoras,
      cargarResumenDiaHora,
      resumenDiaHora,
      cargarSelectsResumenProgramaciones,
      listHistoriales,
      getCanchaStyle,
      hayPrioridades,
      toggleBloqueoCancha,
      totalSlotsDisponibles,
      totalSlotsBloqueados,
      cerrarModoCreacion,
      salirmodoAsignacion,
      getSlotsconfig,
      getSlotsconfigAsignaciones,
      showloadingContenidoSlots,
      showloadingConfirmacionHorarios,
      nombreSlots,
      refreshA,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.grid-wrapper {
  max-height: 500px;
  overflow: auto;
  border: 1px solid #ccc;
  margin-top: 10px;
}

/* GRID */
.grid {
  display: grid;
  min-width: max-content;
}

/* HEADER */
.header {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #f8f9fa;
}

/* BODY */
.body {
  grid-auto-rows: 55px;
}

/* FILA */
.franja-row {
  display: contents;
}

/* CELDAS */
.cell-header {
  border: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 28px; /* 🔥 aire lateral */
  font-weight: 500;

  // min-width: max-content; /* 🔥 CLAVE */
}
.cell {
  border: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 28px; /* 🔥 aire lateral */
  transition: background-color 0.15s ease, box-shadow 0.15s ease;

  // min-width: max-content; /* 🔥 CLAVE */
}
.cell:hover {
  background-color: #f1f8ff; /* azul suave */
  box-shadow: inset 0 0 0 1px #90caf9;
}

/* FRANJA */
.franja-cell {
  position: sticky;
  left: 0;
  background: #f1f3f5;
  z-index: 5;
  font-weight: 600;
}

/* SLOT */
.slot-activo {
  width: 80%;
  height: 60%;
  background: #4caf50;
  border-radius: 6px;
}

.canchas-grid {
  display: inline-flex; /* Cambiado para que crezca según el contenido */
  gap: 4px;
}

.cancha-activa {
  width: 40px; /* Ancho fijo para cada cancha */
  height: 30px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: #f9f9f9;
  font-size: 9px;
  /* padding: 4px; */
  text-align: center;
  margin-inline: 4px;
}
.subcancha {
  width: 40px; /* Ancho fijo para cada cancha */
  background: #fffdfd;
  font-size: 8px;
  padding: 4px;
  text-align: center;
  margin-inline: 4px;
}

//radio
.toggle-group {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.toggle-item {
  padding: 6px 14px;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  user-select: none;
  border: 1px solid transparent;
  background: #f1f3f5;
  color: #495057;
  transition: all 0.15s ease;
}

.toggle-item:hover {
  filter: brightness(0.95);
}
//cursor
.assign-mode {
  cursor: crosshair;
}
.assign-indicator {
  position: fixed;
  top: 0;
  left: 0;
  transform: translate(calc(var(--x) + 12px), calc(var(--y) + 12px));
  padding: 4px 10px;
  border-radius: 999px;
  color: white;
  font-size: 12px;
  pointer-events: none;
  z-index: 9999;
}
.prioridad {
  background: red;
  font-size: 11px;
  color: white;
  padding: 3px;
  border-radius: 3px;
}
.no-prioridad {
  background: rgb(253, 251, 175);
  font-size: 11px;
  color: rgb(50, 50, 50);
  padding: 3px;
  border-radius: 3px;
}
.disponibles {
  background: papayawhip;
  padding: 3px;
  border-radius: 5px;
  font-size: 12px;
}
.bloqueados {
  background: rgb(236, 231, 224);
  padding: 3px;
  border-radius: 5px;
  font-size: 12px;
  margin-left: 10px;
}
.mensaje-salir-modo {
  background: deeppink;
  color: white;
  padding: 8px;
  border-radius: 10px;
  width: 54%;
  cursor: pointer;
  margin-top: 10px;
  text-align: center;
  font-size: 12px;
}
</style>
